@if (status) {
  <div class="op-status-board-header">
    <h2 class="editable-toolbar-title--fixed">
      <small [textContent]="text.status"></small>
      <br/>
      {{ status.name }}
    </h2>
  </div>
}
